module.exports = [{
      plugin: require('/builds/nyaladev/ssc/ssc-frontend/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-166302375-2"},
    },{
      plugin: require('/builds/nyaladev/ssc/ssc-frontend/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":2048},
    }]
